import { FC, HTMLAttributes, ReactNode } from "react";

export interface FieldsetProps extends HTMLAttributes<HTMLFieldSetElement> {
    FieldsetLabel?: FC | string
    id: string
    className?: string
    children?: ReactNode
}

export const Fieldset: FC<FieldsetProps> = ({FieldsetLabel, children, className, id, ...rest}) => {
    return (
        <fieldset id={id} className={`df fd-c w-100 ${className ?? ''}`} {...rest}>
            {FieldsetLabel && (
                <legend className="text s18-600 mb-6 caption legend serif" aria-hidden>
                {typeof FieldsetLabel === 'string' ? FieldsetLabel : <FieldsetLabel />}
                </legend>
            )}
            {children}
        </fieldset>
    )
}